enum DealModes {
  Default = "MODE_DEFAULT",
  Compact = "MODE_COMPACT",
  FullPage = "MODE_FULL_PAGE"
}

export default DealModes
